import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import logo from '../assets/logo.png';

const Header = () => {
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [complianceDropdown, setComplianceDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileComplianceOpen, setMobileComplianceOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (mobileMenuOpen) {
      setMobileServicesOpen(false);
      setMobileComplianceOpen(false);
    }
  };

  const toggleMobileServices = () => setMobileServicesOpen(!mobileServicesOpen);
  const toggleMobileCompliance = () => setMobileComplianceOpen(!mobileComplianceOpen);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* Logo */}
        <div className={styles.logo}>
          <Link to="/" className={styles.logoLink}>
            <div className={styles.logoIcon}>
              <img src={logo} alt="Virtual IP Logo" className={styles.logoImage} />
            </div>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className={styles.desktopNav}>
          <ul className={styles.navList}>
            <li><Link to="/" className={styles.navLink}>HOME</Link></li>
            <li><Link to="/about" className={styles.navLink}>ABOUT</Link></li>

            {/* Services Dropdown */}
            <li
              className={styles.dropdown}
              onMouseEnter={() => setServicesDropdown(true)}
              onMouseLeave={() => setServicesDropdown(false)}
            >
              <span className={styles.navLink}>
                SERVICES <span className={styles.arrow}>▼</span>
              </span>
              {servicesDropdown && (
                <div className={styles.dropdownMenu}>
                  <Link to="/services/cyber-services" className={styles.dropdownItem}>CYBER SECURITY SERVICES</Link>
                  <Link to="/ai-services" className={styles.dropdownItem}>ARTIFICIAL INTELLIGENCE SERVICES</Link>
                  <Link to="/web-services" className={styles.dropdownItem}>
        WEB DEVELOPMENT SERVICES
      </Link>
                </div>
              )}
            </li>

            {/* Compliance Dropdown */}
            <li
              className={styles.dropdown}
              onMouseEnter={() => setComplianceDropdown(true)}
              onMouseLeave={() => setComplianceDropdown(false)}
            >
              <span className={styles.navLink}>
                COMPLIANCE AUDITING <span className={styles.arrow}>▼</span>
              </span>
              {complianceDropdown && (
                <div className={styles.dropdownMenu}>
                  <Link to="/compliance/iso-27001" className={styles.dropdownItem}>ISO 27001 CERTIFICATION ASSISTANCE</Link>
                  <Link to="/compliance/soc2" className={styles.dropdownItem}>SOC 2 COMPLIANCE SUPPORT</Link>
                  <Link to="/compliance/nist" className={styles.dropdownItem}>NIST CYBERSECURITY FRAMEWORK COMPLIANCE</Link>
                  <Link to="/compliance/cis" className={styles.dropdownItem}>CIS CONTROLS (CENTER FOR INTERNET SECURITY)</Link>
                  <Link to="/compliance/hipaa" className={styles.dropdownItem}>HIPAA COMPLIANCE SERVICES</Link>
                  <Link to="/compliance/hitech" className={styles.dropdownItem}>HITECH (HEALTH IT COMPLIANCE)</Link>
                  <Link to="/compliance/gdpr" className={styles.dropdownItem}>GDPR COMPLIANCE SERVICES</Link>
                  <Link to="/compliance/pci-dss" className={styles.dropdownItem}>PCI-DSS COMPLIANCE SERVICES</Link>
                  <Link to="/compliance/fisma" className={styles.dropdownItem}>FISMA (FEDERAL INFORMATION SECURITY)</Link>
                  <Link to="/compliance/cmmc" className={styles.dropdownItem}>CMMC SUPPORT</Link>
                  <Link to="/compliance/fedramp" className={styles.dropdownItem}>FEDRAMP COMPLIANCE</Link>
                  <Link to="/compliance/itar" className={styles.dropdownItem}>ITAR COMPLIANCE</Link>
                  <Link to="/compliance/iso-42001" className={styles.dropdownItem}>ISO/IEC 42001</Link>
                  <Link to="/compliance/cobit" className={styles.dropdownItem}>COBIT (IT GOVERNANCE FRAMEWORK)</Link>
                </div>
              )}
            </li>

            <li><Link to="/awards" className={styles.navLink}>AWARDS & CERTIFICATION</Link></li>
          </ul>
        </nav>

        {/* Desktop Contact Button */}
        <div className={styles.desktopActions}>
          <div className={styles.contactButton}>
            <Link to="/contact" className={styles.contactBtn}>
              CONTACT US <span className={styles.contactArrow}>→</span>
            </Link>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <div className={styles.mobileMenuToggle} onClick={toggleMobileMenu}>
          <div className={`${styles.hamburger} ${mobileMenuOpen ? styles.hamburgerOpen : ''}`}>
            <span></span><span></span><span></span>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`${styles.mobileNav} ${mobileMenuOpen ? styles.mobileNavOpen : ''}`}>
          <div className={styles.mobileNavContent}>
            <div className={styles.mobileNavHeader}>
              <div className={styles.mobileNavTitle}>Menu</div>
              <button className={styles.mobileCloseBtn} onClick={toggleMobileMenu}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <ul className={styles.mobileNavList}>
              <li><Link to="/" className={styles.mobileNavLink} onClick={toggleMobileMenu}>HOME</Link></li>
              <li><Link to="/about" className={styles.mobileNavLink} onClick={toggleMobileMenu}>ABOUT</Link></li>

              {/* Mobile Services Dropdown */}
              <li className={styles.mobileDropdown}>
                <div className={styles.mobileDropdownToggle} onClick={toggleMobileServices}>
                  <span>SERVICES</span>
                  <span className={`${styles.mobileArrow} ${mobileServicesOpen ? styles.mobileArrowOpen : ''}`}>▼</span>
                </div>
                <div className={`${styles.mobileDropdownMenu} ${mobileServicesOpen ? styles.mobileDropdownMenuOpen : ''}`}>
                  <Link to="/services/cyber-services" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>CYBER SECURITY SERVICES</Link>
                  <Link to="/ai-services" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>ARTIFICIAL INTELLIGENCE SERVICES</Link>
                  <Link to="/web-services" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>
  WEB DEVELOPMENT SERVICES
</Link>
                </div>
              </li>

              {/* Mobile Compliance Dropdown */}
              <li className={styles.mobileDropdown}>
                <div className={styles.mobileDropdownToggle} onClick={toggleMobileCompliance}>
                  <span>COMPLIANCE AUDITING</span>
                  <span className={`${styles.mobileArrow} ${mobileComplianceOpen ? styles.mobileArrowOpen : ''}`}>▼</span>
                </div>
                <div className={`${styles.mobileDropdownMenu} ${mobileComplianceOpen ? styles.mobileDropdownMenuOpen : ''}`}>
                  <Link to="/compliance/iso-27001" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>ISO 27001</Link>
                  <Link to="/compliance/soc2" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>SOC 2</Link>
                  <Link to="/compliance/nist" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>NIST</Link>
                  <Link to="/compliance/cis" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>CIS</Link>
                  <Link to="/compliance/hipaa" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>HIPAA</Link>
                  <Link to="/compliance/hitech" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>HITECH</Link>
                  <Link to="/compliance/gdpr" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>GDPR</Link>
                  <Link to="/compliance/pci-dss" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>PCI-DSS</Link>
                  <Link to="/compliance/fisma" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>FISMA</Link>
                  <Link to="/compliance/cmmc" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>CMMC</Link>
                  <Link to="/compliance/fedramp" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>FEDRAMP</Link>
                  <Link to="/compliance/itar" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>ITAR</Link>
                  <Link to="/compliance/iso-42001" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>ISO/IEC 42001</Link>
                  <Link to="/compliance/cobit" className={styles.mobileDropdownItem} onClick={toggleMobileMenu}>COBIT</Link>
                </div>
              </li>
              <li><Link to="/awards" className={styles.mobileNavLink} onClick={toggleMobileMenu}>AWARDS & CERTIFICATION</Link></li>
              <li><Link to="/contact" className={styles.mobileNavLink} onClick={toggleMobileMenu}>CONTACT US</Link></li>
            </ul>

            {/* Mobile Actions */}
            <div className={styles.mobileActions}>
              <div className={styles.mobileSearchIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="21 21l-4.35-4.35"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && <div className={styles.mobileOverlay} onClick={toggleMobileMenu}></div>}
      </div>
    </header>
  );
};

export default Header;
